angular.module('property-price-list')
    .component('propertyPriceListTypeLabel', {
        bindings: {
            type: '<'
        },
        template: `
            <span class="label label-default property-price-list-type {{$ctrl.type}}" ng-if="$ctrl.type != null">{{ "property-price-list.type." + $ctrl.type | translate }}</span>
        `
    })
